import { supabase } from '@/integrations/supabase/client';

/**
 * Resolve o ID do pedido ATIVO (filho mais recente ou o próprio pedido)
 * Usado para garantir que buscamos o histórico correto
 */
export async function resolverPedidoAtivo(pedidoId: string): Promise<string> {
  console.log('🔍 [PEDIDO VERSION] Resolvendo pedido ativo para:', pedidoId);
  
  // Buscar se este pedido tem filhos (versões mais recentes)
  const { data: filhos, error } = await supabase
    .from('pedidos')
    .select('id, version, created_at')
    .eq('pedido_mae_id', pedidoId)
    .order('created_at', { ascending: false })
    .limit(1);

  if (error) {
    console.error('❌ Erro ao buscar pedido filho:', error);
    return pedidoId; // Retorna o original em caso de erro
  }

  // Se há um filho, retorna o ID do filho (versão mais recente)
  if (filhos && filhos.length > 0) {
    console.log('✅ [PEDIDO VERSION] Pedido filho encontrado:', filhos[0].id);
    return filhos[0].id;
  }

  // Se não há filhos, este já é o pedido ativo
  console.log('✅ [PEDIDO VERSION] Este já é o pedido ativo');
  return pedidoId;
}
